/* -------------------------------------------------------------------------- */
/*                                    页面权限                                 */
/* -------------------------------------------------------------------------- */

export const ROLE_PAGE_UUID = '6d54cba3-4130-4e44-9b8e-5795befa405c'

/* -------------------------------------------------------------------------- */
/*                                    操作权限                                 */
/* -------------------------------------------------------------------------- */
export const ROLE_ACTION_UUID = '49a96934-ff5d-4e33-ab12-efdb24263be7'
